import { RecurrenceRule } from ".";

export enum ProviderStatus {
    ACTIVE = "active",
    INACTIVE = "inactive",
}

export enum SessionDeliveryOption {
    IN_PERSON = "in_person",
    REMOTE = "remote",
}

export enum SessionPlaceOfServiceCode {
    TELEHEALTH_PROVIDED_IN_PATIENTS_HOME = "10 - Telehealth Provided in Patient's Home",
    OFFICE = "11 - Office",
}

export enum AppointmentLocation {
    IN_PERSON = "in_person",
    TELETHERAPY = "teletherapy",
}

export enum AppointmentLocationTeletherapy {
    OFFICE = "Office",
    HOME = "Home",
    OTHER = "Other",
}

export enum SessionServiceType {
    CHILD_THERAPY = "child_therapy",
    FAMILY_THERAPY = "family_therapy",
    INDIVIDUAL_THERAPY = "individual_therapy",
    INTUITIVE_EATING = "intuitive_eating",
    MEDICATION_MANAGEMENT = "medication_management",
    PSYCHIATRIC_COUNSELING = "psychiatric_counseling",
    MENTAL_HEALTH_ASSESSMENT = "mental_health_assessment",
    GIFTED_ASSESSMENT = "gifted_assessment",
    SHORT_TERM_EVALUATION_DOCUMENTATION = "short_term_evaluation_documentation",
    TELETHERAPY = "teletherapy",
}

export const SessionLabels: { [key: string]: string } = {
    [SessionServiceType.CHILD_THERAPY]: "Child Therapy",
    [SessionServiceType.FAMILY_THERAPY]: "Family Therapy",
    [SessionServiceType.INDIVIDUAL_THERAPY]: "Individual Therapy",
    [SessionServiceType.INTUITIVE_EATING]: "Intuitive Eating",
    [SessionServiceType.MEDICATION_MANAGEMENT]: "Medication Management",
    [SessionServiceType.PSYCHIATRIC_COUNSELING]: "Psychiatric Counseling",
    [SessionServiceType.MENTAL_HEALTH_ASSESSMENT]: "Mental Health Assessment",
    [SessionServiceType.GIFTED_ASSESSMENT]: "Gifted Assessment",
    [SessionServiceType.SHORT_TERM_EVALUATION_DOCUMENTATION]:
        "Short Term Evaluations & Documentation Services",
    [SessionServiceType.TELETHERAPY]: "Teletherapy",
};

// Provider's session
export interface IProviderSession {
    session_id: string;
    session_history_id: string;
    status: ProviderStatus;
    service: SessionServiceType;
    start_date_time: string;
    end_date_time: string;
    confirmed_end_date_time: string | null;
    confirmed_start_date_time: string | null;
    recurrence_rule: RecurrenceRule;
    delivery_option: SessionDeliveryOption;
    is_cancelled: boolean;
    no_of_sessions: number;
    first_session_date: string | null;
    last_seen_date: string | null;
    session_day: string;
    session_metadata?: {
        is_paused: boolean;
        parent_booking_external_id?: string;
        is_supervisor_intake_session?: boolean;
    };
    external_session_id?: string;
    client: {
        client_id: string;
        first_name: string;
        last_name: string;
    };
    provider: ISessionProvider;
    supervisor?: {
        provider_id: string;
        first_name: string;
        last_name: string;
    };
    session_start_hr: number;
    session_start_min: number;
    session_end_hr: number;
    session_end_min: number;
}

export interface ISessionProvider {
    provider_id: string;
    first_name: string;
    last_name: string;
}
